import { cn } from "~/lib/utils";

const PG_TYPES = [
  { group: "Numeric", types: ["smallint", "integer", "bigint", "decimal", "numeric", "real", "double precision", "serial", "bigserial"] },
  { group: "Text", types: ["text", "varchar", "char"] },
  { group: "Date/Time", types: ["timestamp", "timestamptz", "date", "time", "timetz", "interval"] },
  { group: "Boolean", types: ["boolean"] },
  { group: "JSON", types: ["json", "jsonb"] },
  { group: "UUID", types: ["uuid"] },
  { group: "Binary", types: ["bytea"] },
  { group: "Network", types: ["inet", "cidr", "macaddr"] },
];

// eslint-disable-next-line react-refresh/only-export-components
export const ALLOWED_TYPES = new Set(PG_TYPES.flatMap((g) => g.types));

export function ColumnTypeSelect({
  value,
  onChange,
  className,
  enums,
}: {
  value: string;
  onChange: (value: string) => void;
  className?: string;
  enums?: Array<{ name: string }>;
}) {
  return (
    <select
      aria-label="Column type"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className={cn(
        "h-8 rounded-md border border-border bg-background px-2 text-sm text-foreground",
        className
      )}
    >
      <option value="" disabled>Select type...</option>
      {enums && enums.length > 0 && (
        <optgroup label="Custom Types (Enums)">
          {enums.map((e) => (
            <option key={e.name} value={e.name}>{e.name}</option>
          ))}
        </optgroup>
      )}
      {PG_TYPES.map((group) => (
        <optgroup key={group.group} label={group.group}>
          {group.types.map((t) => (
            <option key={t} value={t}>{t}</option>
          ))}
        </optgroup>
      ))}
    </select>
  );
}
